module.exports = __webpack_public_path__ + "04_hair_brown.fe7c5833.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/04_hair_brown.png
// module id = D/1X
// module chunks = 0